<template>
  <div >
    <vs-dialog scroll  full-screen :loading="loading" v-model="active">
        <!-- <router-view></router-view> -->
        <template #header>
          <h3>
            {{ name }}
          </h3>
        </template>
        <iframe ref="Iframe"   :src="src"  
        frameborder="0"></iframe>
        <template #footer>
          <div></div>
        </template>
        <!-- <YJSProofOfRead :form="params" v-show="viewname=='YJSProofOfReading'"></YJSProofOfRead> -->
    </vs-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      active: false,
      viewname:'',
      params:null,
      loading:false,
      name:null,
      src:"",
    };
  },
  async mounted() {

  },
  methods: {
    handleClick() {},
    dialog(id,name){
      this.src = process.env.VUE_APP_BASE_API + '/createpdf?viewid='+id;
      this.active = true;
      this.name = name;
      console.log(this.name,'name')
      this.iframeLoad();
    },
    iframeLoad(){
      this.loading = true;
    
      this.$nextTick(()=>{
        const iframe = this.$refs.Iframe;
        console.log(iframe,'next');
        if (iframe.attachEvent) { // IE
            iframe.attachEvent('onload', () => { this.loading = false; });
          } else { // 非IE
            iframe.onload =  () => { this.loading = false; };
          }
      })


    
      
    }
  },
};
</script>

<style lang="scss" scoped>

// ::v-deep .vs-sidebar-content{
//   box-shadow: none !important;
// }

// ::v-deep .vs-dialog{
//   max-width: 1200px !important;
//   height:1200px;
// }

::v-deep .vs-dialog--scroll .vs-dialog__content {
    max-height: calc(100vh - 140px);
    overflow: auto;
}
iframe{
  border:0;
  width:1000px;
  height: 1200px;
}
header {
  display: flex;
  height: 68.39px;
  background: white;
  border-radius: 0 0 30px 0;
  justify-content: flex-end;
  padding: 0 20px;
  align-items: center;
}
.title {
  font-family: "KaiTi";
  font-size: 20px;
}
.search {
  cursor: text;
  width: 15rem;
  color: var(--vs-theme-color);
  display: inline-block;
  border-radius: 2rem;
  font-size: 0.85rem;
  line-height: 2rem;
  height: 40px;
  outline: none;
  transition: all 0.2s ease;
  background: rgba(0, 0, 0, 0.05);
  background-size: 1rem;
  display: block;
  border-radius: 0;
  border: 0;
  padding: 4px 4px 4px 20px;
  opacity: 1;
  border-radius: 14px 5px 14px 14px;
}
.all {
  background: white;
  width: 100%;
  height: 100vh;
}
.page {
  margin-left: 260px;
  padding-left: 0 !important;
  background-color: #f4f7f8 !important;

  display: block;
  position: relative;
  margin-bottom: 0;
  transition: all 0.25s ease;
  width: calc(100% - 260px);
  max-height: calc(100vh - 68.38px);
  height: calc(100vh - 68.38px);

  border-radius: 14px 0 0 0;
}

@media (max-width: 1000px) {
  .page {
    padding-left: 0;
    margin-left: 0 !important;
    width: 100%;
  }
}
</style>